import type { SocialMetaData } from 'services/content/types'
import type { RawPage } from '../types'

export function socialMetaDataParser(rawResponse: RawPage): SocialMetaData {
  const { acf, title } = rawResponse.tiles[0]
  const { socialSharing = {} } = acf
  const { facebook = {} } = socialSharing

  return {
    title: facebook.title || title,
    image: facebook.image,
  }
}
